import _ from 'lodash';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class SignupService {

  constructor(
    private http: HttpClient,
    private cookieService: CookieService
  ) { }

  signup(email, password, name, reCAPTCHAToken = null) {
    const token = this.cookieService.get('accessToken');
    const p = { email, password, name, reCAPTCHAToken };
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify(p))}`
    ];
    return this.http.post('/api/org/signUp', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  initiateVerifyEmail() {
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`
    ];
    return this.http.post('/api/initiateVerifyEmail', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  updateEmail(data) {
    const token = this.cookieService.get('accessToken');
    const p = { ...data };
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify(p))}`
    ];
    return this.http.post('/api/org/update', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  contactUs(data) {
    const token = this.cookieService.get('accessToken');
    const p = { ...data };
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify(p))}`
    ];
    return this.http.post('/api/org/support', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  addBankAccount(plaid_token, plaid_account_id) {
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `plaid_token=${plaid_token}`,
      `plaid_account_id=${plaid_account_id}`,
      `plaidVersion=1`
    ];
    return this.http.post('/api/org/addBankAccount', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  addBankAccountRoutingNumber(bankAccountToken) {
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `bankAccountToken=${bankAccountToken}`
    ];
    return this.http.post('/api/org/addBankAccount', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  getUser() {
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`
    ];
    return this.http.post('/api/user', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  getInvoicesDue() {
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`
    ];
    return this.http.post('/api/getInvoicesDue', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }
}
